import React from "react";
import styled from "styled-components/macro";
import { device } from "../device";
import tuluLogoWhite from "../../images/tuluLogoWhite.png";

const CoverHeader = ({ img, title, subtitle }) => {
  return (
    <MainCont img={img}>
      <Column>
        <Img src={tuluLogoWhite} />
        <HeadLine>{title}</HeadLine>
        <ParaCont>{subtitle}</ParaCont>
      </Column>
    </MainCont>
  );
};

export default CoverHeader;

const MainCont = styled.div`
  font-family: "Lexend", serif;
  background-image: ${(props) =>
    `linear-gradient(to right bottom, #234d5b66, #234d5b66), url(${props.img})`};
  background-size: cover;
  background-blend-mode: multiply;

  display: flex;
  align-items: center;
  flex-direction: row;
  mix-blend-mode: multiply;
  @media ${device.mobileS} {
    //margin-top: -40px;
    //background-position-x: -5vw;
    //height: calc(100vw + 40px);
    height: 100vw;
    padding-bottom: 10px;
  }
  @media ${device.tablet} {
    margin-top: 0px;
    background-position-x: 0vw;
    background-position: center;
    height: 100vh;
    margin-bottom: 0px;
  }
`;

const HeadLine = styled.h1`
  color: #fff;
  white-space: pre-wrap;
  font-weight: bold;
  font-family: "Lexend", serif;
  @media ${device.mobileS} {
    margin: 10px 0 0;
    font-size: 2.1em;
    width: 250px;
  }
  @media ${device.tablet} {
    margin: 20px 0 0;
    font-size: 4em;
    width: 100%;
  }
`;

const ParaCont = styled.div`
  display: flex;
  white-space: pre-wrap;
  flex-direction: column;
  color: white;
  font-family: "DMSans", serif;
  @media ${device.mobileS} {
    // width: 250px;
    margin: 5px 0 15px 0;
    font-size: 15px;
    line-height: 1.2;
  }
  @media ${device.tablet} {
    margin: 20px 0;
    font-size: 20px;
    width: 440px;
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.mobileS} {
    margin-top: 140px;
    padding-left: 32px;
    width: 90vw;
  }
  @media ${device.tablet} {
    margin-top: 300px;
    padding: 40px 80px;
  }
`;

const Img = styled.img`
  @media ${device.mobileS} {
    width: 90px;
  }
  @media ${device.tablet} {
    width: 250px;
  }
`;
